import { render, staticRenderFns } from "./CustomNavbar.vue?vue&type=template&id=53f7b691&scoped=true"
import script from "./CustomNavbar.vue?vue&type=script&lang=js"
export * from "./CustomNavbar.vue?vue&type=script&lang=js"
import style0 from "./CustomNavbar.vue?vue&type=style&index=0&id=53f7b691&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7b691",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/bluepay-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f7b691')) {
      api.createRecord('53f7b691', component.options)
    } else {
      api.reload('53f7b691', component.options)
    }
    module.hot.accept("./CustomNavbar.vue?vue&type=template&id=53f7b691&scoped=true", function () {
      api.rerender('53f7b691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomNavbar.vue"
export default component.exports